import { Routes, Route } from 'react-router-dom';
import {
  LayoutDashboard, Building2, Users, ClipboardList, FileText,
  Receipt, FileSpreadsheet, Calendar, Settings, MapPin, MessageSquareWarning, FileUp, BookOpen, Inbox, Newspaper, Tags, MessageSquareQuote, Banknote, Bell,
} from 'lucide-react';
import PortalLayout, { type NavItem } from '../../components/PortalLayout';

import Dashboard from './Dashboard';
import Properties from './Properties';
import Staff from './Staff';
import Assignments from './Assignments';
import Reports from './Reports';
import Expenses from './Expenses';
import ExpenseReports from './ExpenseReports';
import AccountReports from './AccountReports';
import Locations from './Locations';
import Features from './Features';
import PriceRanges from './PriceRanges';
import Meetings from './Meetings';
import Complaints from './Complaints';
import Requests from './Requests';
import Blog from './Blog';
import Testimonials from './Testimonials';
import StaffHandbooks from './StaffHandbooks';
import Bills from './Bills';
import MonthlyExpenses from './MonthlyExpenses';
import NoticeBoard from './NoticeBoard';
import Profile from '../../components/Profile';

const navItems: NavItem[] = [
  { to: '/admin', label: 'Dashboard', icon: <LayoutDashboard className="h-5 w-5" />, end: true },
  { to: '/admin/properties', label: 'Properties', icon: <Building2 className="h-5 w-5" /> },
  { to: '/admin/staff', label: 'Staff & Users', icon: <Users className="h-5 w-5" /> },
  { to: '/admin/assignments', label: 'Assignments', icon: <ClipboardList className="h-5 w-5" /> },
  { to: '/admin/reports', label: 'Status Report', icon: <FileText className="h-5 w-5" /> },
  { to: '/admin/complaints', label: 'Complaints', icon: <MessageSquareWarning className="h-5 w-5" /> },
  { to: '/admin/bills', label: 'Bills', icon: <Banknote className="h-5 w-5" /> },
  { to: '/admin/expenses', label: 'My Expenses', icon: <Receipt className="h-5 w-5" /> },
  { to: '/admin/monthly-expenses', label: 'Monthly Expenses', icon: <FileSpreadsheet className="h-5 w-5" /> },
  { to: '/admin/expense-reports', label: 'Site Expenses', icon: <FileUp className="h-5 w-5" /> },
  { to: '/admin/account-reports', label: 'Financial Account', icon: <FileUp className="h-5 w-5" /> },
  { to: '/admin/requests', label: 'Requests', icon: <Inbox className="h-5 w-5" /> },
  { to: '/admin/meetings', label: 'Meetings', icon: <Calendar className="h-5 w-5" /> },
  { to: '/admin/locations', label: 'States & Areas', icon: <MapPin className="h-5 w-5" /> },
  { to: '/admin/features', label: 'Features', icon: <Settings className="h-5 w-5" /> },
  { to: '/admin/price-ranges', label: 'Price Ranges', icon: <Tags className="h-5 w-5" /> },
  { to: '/admin/staff-handbook', label: 'Staff Handbook', icon: <BookOpen className="h-5 w-5" /> },
  { to: '/admin/blog', label: 'Blog', icon: <Newspaper className="h-5 w-5" /> },
  { to: '/admin/testimonials', label: 'Testimonials', icon: <MessageSquareQuote className="h-5 w-5" /> },
  { to: '/admin/notices', label: 'Notices', icon: <Bell className="h-5 w-5" /> },
];

export default function Admin() {
  return (
    <PortalLayout title="Admin Portal" navItems={navItems}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="properties" element={<Properties />} />
        <Route path="staff" element={<Staff />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="reports" element={<Reports />} />
        <Route path="complaints" element={<Complaints />} />
        <Route path="bills" element={<Bills />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="monthly-expenses" element={<MonthlyExpenses />} />
        <Route path="expense-reports" element={<ExpenseReports />} />
        <Route path="account-reports" element={<AccountReports />} />
        <Route path="requests" element={<Requests />} />
        <Route path="meetings" element={<Meetings />} />
        <Route path="locations" element={<Locations />} />
        <Route path="features" element={<Features />} />
        <Route path="price-ranges" element={<PriceRanges />} />
        <Route path="staff-handbook" element={<StaffHandbooks />} />
        <Route path="blog" element={<Blog />} />
        <Route path="testimonials" element={<Testimonials />} />
        <Route path="notices" element={<NoticeBoard />} />
        <Route path="profile" element={<Profile />} />
      </Routes>
    </PortalLayout>
  );
}
